/** Person property key used for PostHog feature-flag targeting of Galactus scopes. */
export const POSTHOG_PERMISSIONS_FLAG_PROPERTY = "permissions";
